import BucketApiRequest from "./BucketApiRequest";
import { GET_INCOME_SOURCES_URL } from "../ApiUrls";

export default class IncomeSourcesRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_INCOME_SOURCES_URL;
  };
}
